import * as React from "react";

const Facebook = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5824_1058)">
      <path
        d="M17.3301 4.31708H19.7037V0.183083C19.2942 0.12675 17.8859 0 16.2457 0C12.8235 0 10.4791 2.15258 10.4791 6.10892V9.75H6.70264V14.3715H10.4791V26H15.1093V14.3726H18.7331L19.3083 9.75108H15.1082V6.56717C15.1093 5.23142 15.469 4.31708 17.3301 4.31708Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5824_1058">
        <rect width={26} height={26} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default Facebook;